import { schema } from "normalizr";

const etaTemplateBoilerplate = new schema.Entity("etaTemplateBoilerplate");

export default {
    ETA_TEMPLATE_BOILERPLATE: { data: [etaTemplateBoilerplate] }
};
